import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 70 — "HubSpot freelancer / VA specialist" cluster service links.
 *
 * Every Batch 70 article routes its primary commercial link to
 * /hubspot-revops-architect. The answer-first leads in batch70Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /hubspot-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH70_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "hire-hubspot-freelancer": {
    url: "/hubspot-revops-architect",
    anchor:
      /marketplace listing that rotates the freelancer is a hire the team rebriefs every project/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-virtual-assistant": {
    url: "/hubspot-revops-architect",
    anchor:
      /HubSpot portal run by a generalist is a portal the workflow breaks on/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hire-hubspot-va-philippines": {
    url: "/hubspot-revops-architect",
    anchor:
      /cheap HubSpot VA with no portal depth is the most expensive hire of all/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-freelancer-vs-employee": {
    url: "/hubspot-revops-architect",
    anchor:
      /full-time employee with no HubSpot depth is a hire the portal outgrows/i,
    label: "hire a HubSpot RevOps architect",
  },
  "best-hubspot-freelancers": {
    url: "/hubspot-revops-architect",
    anchor:
      /marketplace listing with a badge and no portal depth is a hire the team rekeys/i,
    label: "hire a HubSpot RevOps architect",
  },
};
